import { IconButton, Id, Trigger, useBulkEdit } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DistributionListContactsBulkEditDrawer } from "../contacts/DistributionListContactsBulkEditDrawer";
import { birthdayWidgetService } from "../dashboard/widgets/birthdays/service";
import { InvitationListAttachBulkEditContactsDrawer } from "../events/eventDetails/invitationList/InvitationListAttachBulkEditContactsDrawer";

export const ContactBulkEditAction: FC<{ contactFilterId: Id | null }> = ({ contactFilterId }) => {
	const { t } = useTranslation();
	const { selectedRows, availableItemIds } = useBulkEdit();
	const queryClient = useQueryClient();

	return (
		<>
			<Trigger
				render={(props) => (
					<DistributionListContactsBulkEditDrawer
						{...props}
						handleClose={() => {
							void queryClient.invalidateQueries({ queryKey: birthdayWidgetService.key });
							props.handleClose();
						}}
						contactFilterId={contactFilterId}
					/>
				)}
			>
				{(props) => (
					<IconButton
						{...props}
						type="button"
						title={t("Add contacts to distribution list")}
						size="small"
						disabled={selectedRows.length === 0 || availableItemIds.length === 0}
						iconSrc="/groups.svg"
					/>
				)}
			</Trigger>
			<Trigger
				render={(props) => <InvitationListAttachBulkEditContactsDrawer {...props} contactFilterId={contactFilterId} />}
			>
				{(props) => (
					<IconButton
						{...props}
						type="button"
						title={t("Add contacts to invitation list")}
						size="small"
						disabled={selectedRows.length === 0 || availableItemIds.length === 0}
						icon="calendar"
					/>
				)}
			</Trigger>
		</>
	);
};
